import useToast, { ToastType } from './useToast';

import { nextTrpc } from '~/trpc';

/**
 * Hook to fetch and manage integration connections
 */
const useIntegrationConnections = () => {
  const { enqueueToast } = useToast();
  // Query to fetch connected integrations
  const {
    data: integrationConnectionsData,
    refetch: refetchIntegrationConnections
  } = nextTrpc.integrationConnections.list.useQuery();

  const { data: authorizedConfigsData } =
    nextTrpc.integrationConfigs.list.useQuery();

  // Mutation to delete a connection
  const deleteConnectionMutation =
    nextTrpc.integrationConnections.deleteConnection.useMutation({
      onSuccess: () => {
        // Refetch connections after successful deletion
        void refetchIntegrationConnections();
        enqueueToast({
          message: 'Integration deleted.',
          type: ToastType.SUCCESS
        });
      },
      onError: (error) => {
        console.error(error);
        enqueueToast({
          message: 'Unable to delete integration.',
          type: ToastType.ERROR
        });
      }
    });
  const deleteIntegrationConnection = (integrationConnectionId: string) => {
    deleteConnectionMutation.mutate({ integrationConnectionId });
  };

  return {
    integrationConnectionsData: integrationConnectionsData?.items,
    authorizedIntegrationConfigs: authorizedConfigsData?.items,
    refetchIntegrationConnections,
    deleteIntegrationConnection
  };
};

export default useIntegrationConnections;
